import { f7 } from 'framework7-react';
import { FC } from 'react';
import style from './servicePromotionCardStyle.module.css';
import { paths } from '@/config/paths';

export const ServicePromotionCard: FC = () => {
  const handleClickButton = () => {
    f7.views.main.router.navigate(paths.servicesAll);
  };

  return (
    <div className={style['card-wrapper']}>
      <div className={style['text-content']}>
        <div className={style['title']}>売却からメンテナンス、レンタルまで</div>
        <div className={style['subtitle']}>
          あなたの
          <span className={style['highlight']}>
            カーライフをまとめてサポート
          </span>
        </div>
      </div>

      <div className={style['icon-row']}>
        <div className={style['icon-item']}>
          <i className="icon-car-front" />
        </div>
        <div className={style['icon-item']}>
          <i className="icon-tool" />
        </div>
        <div className={style['icon-item']}>
          <i className="icon-cart" />
        </div>
        <div className={style['icon-item']}>
          <i className="icon-rent-car" />
        </div>
      </div>

      <button className={style['cta-button']} onClick={handleClickButton}>
        サービスを詳しく見る
        <i className="icon-right" />
      </button>
    </div>
  );
};
